import React from 'react';
import * as Routes from '@/modules/routes';
import I18n from 'i18n-js';
import ILesson from '@/types/api/Lessons';
import ITag from '@/types/api/Tags';
import { twMerge } from '@/utils';
import NumberBadge from '@/components/shared/NewDashboard/Cards/NumberBadge';
import EngineeringBanner from './EngineeringBanner';
import DashboardCard from '../DashboardCard';

type LessonCardProps = {
  lesson: ILesson,
  overviewColor: string,
  programId: number,
  unitColor: string,
};

const LessonCard = ({ lesson, overviewColor, programId, unitColor }: LessonCardProps) => {
  const lessonPath = Routes.shared_program_lesson_slide_shows_path(programId, lesson.id);
  const lessonNumber = lesson?.title_number;
  const performanceExpectations = lesson.performance_expectations?.filter((pe: ITag) => !pe.value_en.includes('ETS'));
  const viewLessonLabel = lessonNumber
    ? `${I18n.t('go_to', { name: lessonNumber })}: ${lesson.title}`
    : `${I18n.t('go_to', { name: lesson.title })}`;

  return (
    <DashboardCard
      ariaLabel={viewLessonLabel}
      badge={lesson.engineering_icon ? (
        <EngineeringBanner
          className="tw-absolute tw-right-4 tw--top-0.5 tw-z-[1000]"
          unitColor={unitColor}
        />
      ) : undefined}
      href={lessonPath}
      imageUrl={lesson.image_url}
      numberLabel={lessonNumber
        ? <NumberBadge color={overviewColor} location="lessonCard" number={lessonNumber} />
        : undefined}
      title={lesson.title}
    >
      {performanceExpectations?.length > 0 && (
        <div className="tw-absolute tw-top-4 tw-left-4 tw-flex tw-z-10">
          {performanceExpectations.slice(0, 2).map((pe: ITag) => (
            <div
              key={pe.id}
              className={twMerge(
                'tw-flex tw-justify-center tw-items-center tw-rounded-sm tw-h-6 tw-bg-green tw-text-white',
                'tw-px-4 tw-mr-2 tw-relative',
              )}
              style={{ backgroundColor: `#${unitColor}`, boxShadow: '0px 5px 5px 0px rgba(0,0,0,0.5)' }}
            >
              <span className="tw-z-10 tw-font-bold">{pe.value_en}</span>
            </div>
          ))}
        </div>
      )}
    </DashboardCard>
  );
};

export default LessonCard;
